export default __webpack_public_path__ + "static/media/edu.7dc135ce.svg";